import { useAccountSecurity } from "./useAccountSecurity";
import { PrimaryEmailCard } from "./PrimaryEmail";
import { AuthenticationMethodsCard } from "./AuthenticationMethods";
import { PasswordChangeForm } from "./PasswordChange";
import { ActiveBrowserSessionsCard } from "./ActiveBrowserSessions";
import { AccountDataExportControl } from "./AccountDataExport";
import { AccountDeletionControl } from "./AccountDeletion";

export function AccountSecurity({ nowUnixMs }: { nowUnixMs?: number }) {
  const security = useAccountSecurity();
  return (
    <>
      <PrimaryEmailCard accountSecurity={security} />
      <AuthenticationMethodsCard accountSecurity={security} />
      {security.snapshot?.methods.password ? (
        <PasswordChangeForm onChangePassword={security.changePassword} />
      ) : null}
      <ActiveBrowserSessionsCard
        accountSecurity={security}
        nowUnixMs={nowUnixMs}
      />
      <AccountDataExportControl accountSecurity={security} />
      <AccountDeletionControl accountSecurity={security} />
    </>
  );
}
